import { createRouter, createWebHistory } from 'vue-router'

// Views
import Home from '../views/Home.vue'
import About from '../views/About.vue'
import Services from '../views/Services.vue'
import SmartHome from '../views/SmartHome.vue'
import Location from '../views/Location.vue'
import Reviews from '../views/Reviews.vue'
import Contact from '../views/Contact.vue'
import NotFoundPage from '../views/NotFoundPage.vue'
import PrivacyPolicyPage from '../views/PrivacyPolicyPage.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: 'VI-GAS - Autoryzowany serwis Viessmann',
      description: 'VI-GAS - Instalacja i naprawa kotłów gazowych, pomp ciepła i systemów grzewczych Viessmann'
    }
  },
  {
    path: '/o-nas',
    name: 'About',
    component: About,
    meta: {
      title: 'O nas - VI-GAS',
      description: 'Poznaj VI-GAS - autoryzowany serwis Viessmann z doświadczeniem w instalacji i naprawie systemów grzewczych'
    }
  },
  {
    path: '/oferta',
    alias: ['/serwis'],
    name: 'Services',
    component: Services,
    meta: {
      title: 'Oferta - VI-GAS',
      description: 'Usługi serwisowe Viessmann - instalacja, naprawa, przeglądy techniczne systemów grzewczych'
    }
  },
  {
    path: '/smart-dom',
    name: 'SmartHome',
    component: SmartHome,
    meta: {
      title: 'Smart Dom - VI-GAS',
      description: 'Inteligentne systemy grzewcze Viessmann - sterowanie z pośbem, oszczędność energii'
    }
  },
  {
    path: '/lokalizacja',
    name: 'Location',
    component: Location,
    meta: {
      title: 'Lokalizacja - VI-GAS',
      description: 'Znajdź VI-GAS - autoryzowany serwis Viessmann w Twojej okolicy'
    }
  },
  {
    path: '/opinie',
    name: 'Reviews',
    component: Reviews,
    meta: {
      title: 'Opinie klientów - VI-GAS',
      description: 'Przeczytaj opinie zadowolonych klientów serwisu VI-GAS'
    }
  },
  {
    path: '/kontakt',
    name: 'Contact',
    component: Contact,
    meta: {
      title: 'Kontakt - VI-GAS',
      description: 'Skontaktuj się z VI-GAS - serwisem Viessmann. Telefon, email, formularz kontaktowy'
    }
  },
  {
    path: '/polityka-prywatnosci',
    name: 'PrivacyPolicy',
    component: PrivacyPolicyPage,
    meta: {
      title: 'Polityka prywatności i cookies | VI-GAS',
      description: 'Informacje o przetwarzaniu danych osobowych i plikach cookies na stronie VI-GAS.'
    }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFoundPage,
    meta: {
      title: '404 - Strona nie istnieje | VI-GAS',
      description: 'Nie znaleziono strony, której szukasz.'
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 }
  }
})

// Update document title and meta description based on route
router.beforeEach((to) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if (to.meta.description) {
    let metaDescription = document.querySelector('meta[name="description"]')
    if (!metaDescription) {
      metaDescription = document.createElement('meta')
      metaDescription.setAttribute('name', 'description')
      document.head.appendChild(metaDescription)
    }
    metaDescription.setAttribute('content', to.meta.description)
  }
  return true
})

export default router
